import(/* webpackMode: "eager" */ "/var/www/vhosts/adminphu.phucbaokhang.com.vn/httpdocs/app/src/app/error.tsx");
